import React from 'react';
import LegalPage from './LegalPage';

export default function CGU() {
  return (
    <LegalPage
      title="Conditions Générales d'Utilisation"
      subtitle="CGU — Plateforme TripNova SaaS"
      lastUpdate="31 mai 2026"
      testid="page-cgu"
    >
      <h2>1. Objet</h2>
      <p>
        Les présentes Conditions Générales d'Utilisation (ci-après « <strong>CGU</strong> ») régissent
        l'accès et l'utilisation de la plateforme <strong>TripNova SaaS</strong> (ci-après la « Plateforme »),
        un logiciel de gestion CRM dédié aux agences de voyages, édité par l'Éditeur.
      </p>
      <p>
        L'utilisation de la Plateforme implique l'acceptation pleine et entière des présentes CGU par
        l'Utilisateur, qu'il soit chef d'agence, agent commercial ou tout autre collaborateur autorisé.
      </p>

      <h2>2. Définitions</h2>
      <ul>
        <li><strong>Utilisateur</strong> : toute personne physique disposant d'un compte sur la Plateforme.</li>
        <li><strong>Agence cliente</strong> ou <strong>Tenant</strong> : entité juridique (agence de voyages) ayant souscrit à la Plateforme.</li>
        <li><strong>Données</strong> : ensemble des informations saisies, importées ou générées par l'Utilisateur dans la Plateforme.</li>
        <li><strong>Service</strong> : ensemble des fonctionnalités fournies par la Plateforme.</li>
      </ul>

      <h2>3. Accès au Service</h2>
      <p>
        L'accès au Service est réservé aux Utilisateurs munis d'identifiants valides (téléphone + mot de passe).
        Chaque Agence cliente bénéficie d'un espace dédié, totalement isolé des autres Agences (architecture multi-tenant).
      </p>
      <p>
        L'Utilisateur s'engage à conserver la confidentialité de ses identifiants et à ne pas les
        partager avec des tiers. Toute action effectuée sous son compte est réputée avoir été effectuée par lui-même.
      </p>

      <h2>4. Obligations de l'Utilisateur</h2>
      <p>L'Utilisateur s'engage à :</p>
      <ul>
        <li>Utiliser le Service conformément à sa destination professionnelle.</li>
        <li>Ne pas tenter d'accéder aux données d'autres Agences (multi-tenant violation).</li>
        <li>Ne pas tenter de contourner les mécanismes de sécurité (rate limiting, authentification, audit logs).</li>
        <li>Saisir des informations exactes et tenues à jour, notamment concernant les clients et transactions financières.</li>
        <li>Respecter la réglementation applicable, notamment en matière de protection des données personnelles (RGPD, loi algérienne 18-07).</li>
      </ul>

      <h2>5. Propriété intellectuelle</h2>
      <p>
        L'Éditeur conserve l'ensemble des droits de propriété intellectuelle sur la Plateforme, son code source,
        son interface graphique, sa documentation et ses bases de données structurelles.
      </p>
      <p>
        L'Utilisateur conserve la propriété pleine et entière des Données qu'il saisit ou importe.
        L'Éditeur n'acquiert aucun droit sur ces Données autres que ceux strictement nécessaires à la fourniture du Service.
      </p>

      <h2>6. Disponibilité du Service</h2>
      <p>
        L'Éditeur met en œuvre les moyens raisonnables pour assurer la disponibilité du Service 24h/24, 7j/7,
        avec un objectif de disponibilité de <strong>99,5 %</strong> sur une base mensuelle (hors maintenance
        planifiée et cas de force majeure).
      </p>
      <p>
        Les opérations de maintenance planifiée sont annoncées avec un préavis raisonnable.
      </p>

      <h2>7. Sécurité et sauvegardes</h2>
      <ul>
        <li>Toutes les communications avec la Plateforme sont chiffrées en HTTPS (TLS 1.2 minimum).</li>
        <li>Les mots de passe sont stockés sous forme de hash bcrypt.</li>
        <li>Une sauvegarde automatique quotidienne de la base de données est réalisée.</li>
        <li>Un journal d'audit (audit log) trace les actions sensibles (création, modification, suppression).</li>
        <li>La plateforme est conforme aux recommandations <strong>OWASP Top 10</strong>.</li>
      </ul>

      <h2>8. Limitation de responsabilité</h2>
      <p>
        L'Éditeur ne saurait être tenu responsable :
      </p>
      <ul>
        <li>Des conséquences résultant de l'utilisation incorrecte du Service par l'Utilisateur.</li>
        <li>Des pertes de données causées par une mauvaise manipulation de l'Utilisateur.</li>
        <li>Des indisponibilités liées à des cas de force majeure (panne réseau, attaque DDoS, défaillance fournisseur tiers).</li>
        <li>Des dommages indirects (perte de chiffre d'affaires, manque à gagner, atteinte à l'image).</li>
      </ul>

      <h2>9. Suspension ou résiliation</h2>
      <p>
        L'Éditeur se réserve le droit de suspendre ou résilier l'accès au Service en cas de :
      </p>
      <ul>
        <li>Non-paiement de l'abonnement (sauf période de bêta gratuite).</li>
        <li>Violation grave des présentes CGU.</li>
        <li>Tentative de fraude, intrusion ou compromission de la sécurité.</li>
      </ul>
      <p>
        En cas de résiliation, l'Agence cliente dispose d'un délai de <strong>30 jours</strong> pour
        télécharger ses Données via les fonctionnalités d'export.
      </p>

      <h2>10. Modifications des CGU</h2>
      <p>
        L'Éditeur se réserve le droit de modifier les présentes CGU à tout moment. Les Utilisateurs seront
        informés par email ou notification in-app au moins 30 jours avant l'entrée en vigueur des modifications.
      </p>

      <h2>11. Loi applicable et juridiction</h2>
      <p>
        Les présentes CGU sont régies par le droit algérien. En cas de litige, et après tentative de résolution
        amiable, compétence est attribuée aux tribunaux compétents d'Alger.
      </p>

      <h2>12. Contact</h2>
      <p>
        Pour toute question relative aux présentes CGU, contactez-nous à :{' '}
        <a href="mailto:aatvgeste@gmail.com">aatvgeste@gmail.com</a>
      </p>
    </LegalPage>
  );
}
